import { mapFromLogin } from 'mappings/loginMapping';
import { LogDTO } from 'dto/system/logDTO';
import LoginDTO from 'dto/identity/loginDTO';
import Login from 'models/identity/login';
import AppError from 'utils/appError';
import http from './httpService';

//the start of every session: who the API sees behind the token (GET users/login)
export async function apiLoginUser(accessToken: string): Promise<Login | undefined> {
  try {
    const ar = await http.get<LoginDTO>('/users/login', http.getRequestConfig(accessToken));

    return mapFromLogin(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//the signed-in user's own UI and mail language (PUT users/me/language); an empty code means automatic
export async function apiSetMyLanguage(languageCode: string, accessToken: string): Promise<void> {
  try {
    await http.put('/users/me/language', { languageCode: languageCode }, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//the client log of an error (components/Notification/ErrorMessageService.ts)
export async function apiAddProcessLog(logDto: LogDTO, accessToken: string): Promise<void> {
  try {
    await http.post(`/users/processlog`, logDto, http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
